import { VStack } from "@/components/Layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Header } from "./-components/Header";
import { useHeader } from "./-hooks/useHeader";
import { getOperationPackageInstance } from "./-query/api";

export const Route = createFileRoute(
  "/_staff/it-operation-core/_detail/operation-instances/$instanceId/_layout",
)({
  loader: ({ params }) => getOperationPackageInstance(params),
  component: RouteComponent,
});

function RouteComponent() {
  const instance = Route.useLoaderData();

  const header = useHeader({ instance });

  return (
    <VStack>
      <Header {...instance} {...header} />
      <Outlet />
    </VStack>
  );
}
